import React from "react";
import {
  michelinLogo,
  MichelinCommercialLogo,
  MichelinMyTechXpertLogo,
} from "../../assets/index";
import "./HeaderStyle.scss";

const Header: React.FC = () => {
  return (
    <header className="headerContainer">
      <div className="logoContainer">
        <img src={MichelinCommercialLogo} className="michelin-logo" />
      </div>
      <div className="mytechxpertLogoContainer">
        <img src={MichelinMyTechXpertLogo} className="mytechxpert-logo" />
      </div>
      {/* <div className="header-text">
        <h1>MICHELIN MyTechXpert</h1>
      </div> */}
    </header>
  );
};

export default Header;
